import BossModel from "@/models/BossModel";

export default class Icon extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/type/icon';

    /**
     *
     * @type {string}
     */
    static entity = 'productTypeIcons';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            image: this.attr(null),
        }
    }

    /**
     *
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api().limit(0).where('is_active', true).get(true);
    }

    /**
     *
     * @returns {*}
     */
    static loadAll() {
        return this.api()
            .limit(0)
            .where('is_active', true)
            .get(true);
    }
}
